import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from 'src/app/route-animate';

@Component({
  selector: 'app-events-page',
  templateUrl: './events-page.component.html',
  styleUrls: ['./events-page.component.css'],
  animations: [slideInAnimation],
})
export class EventsPageComponent implements OnInit { 
  constructor() {}

  ngOnInit(): void {
  }
 
}
